const serviceTypes = {
    LOGOS: 'Logos',
    INSIGHTS: 'Insights',
    DISCOVER: 'Discover',
    MATCHED_APPS: 'Matched Apps',
    MATCHED_PAGES: 'Matched Pages',
    MATCHED_VIDEOS: 'Matched Videos',
    AI_CONTEXT_BUILDER: 'AI Context Builder',
    APP_CONTEXTS_CREATION: 'App Contexts Creation',
};

export default serviceTypes;
